import React from "react"
import { useTheme } from "styled-components"

import ImagePreload from "components/image-preload"
import HeroContent from "../content"
import { Container, Content, BackgroundImage, Overlay, ButtonsContainer } from "./styles"

const BannerHero = ({
  heading,
  preheading,
  subheading,
  backgroundImages,
  minHeight,
  variant,
  buttonElement,
  secondaryButtonElement,
  hasOverlay,
  elRef,
  signupForm,
  dataId,
  hideOnPageLoad,
  ...props
}) => {
  const theme = useTheme()

  const bgImages = backgroundImages && [
    {
      screenSize: 1200,
      url: backgroundImages.desktop,
      transforms: `c_fill,g_auto,w_1440,h_${
        minHeight || (variant === "slim" ? 320 : 400)
      },q_auto,f_auto,fl_lossy`,
    },
    {
      screenSize: 1024,
      url: backgroundImages.desktop,
      transforms: `c_fill,g_auto,w_1200,h_${
        minHeight || (variant === "slim" ? 320 : 400)
      },q_auto,f_auto,fl_lossy`,
    },
    {
      screenSize: 768,
      url: backgroundImages.desktop,
      transforms: `c_fill,g_auto,w_1024,h_${
        minHeight || (variant === "slim" ? 320 : 400)
      },q_auto,f_auto,fl_lossy`,
    },
    {
      screenSize: 500,
      url: backgroundImages.tablet,
      transforms: `c_fill,g_auto,w_768,h_${
        minHeight || (variant === "slim" ? 420 : 500)
      },q_auto,f_auto,fl_lossy`,
    },
    {
      url: backgroundImages.mobile,
      transforms: `c_fill,g_auto,w_500,h_${
        minHeight || (variant === "slim" ? 520 : 600)
      },q_auto,f_auto,fl_lossy`,
    },
  ]

  return (
    <Container
      hideOnPageLoad={hideOnPageLoad}
      data-exp-id={dataId}
      ref={elRef}
      minHeight={minHeight}
      variant={variant}
      {...props}
    >
      {bgImages && theme.component.onTop && <ImagePreload images={bgImages} />}
      {bgImages && <BackgroundImage images={bgImages} alt="" lazy={!theme.component.onTop} />}
      {hasOverlay && <Overlay />}
      <Content>
        <HeroContent preheading={preheading} heading={heading} body={subheading} />
        {secondaryButtonElement ? (
          <ButtonsContainer>
            {buttonElement}
            {secondaryButtonElement}
          </ButtonsContainer>
        ) : (
          buttonElement
        )}
        {signupForm}
      </Content>
    </Container>
  )
}

export default BannerHero
